import { Injectable } from "@angular/core";
import { TaxiPonto } from '@tivic-team/manager-ts/dist/mob/entities/taxi/taxi-ponto.entity';
import { ApiController } from 'app/controllers/api-controller.interface';
import { TaxiPontoListDTO } from "app/model/dtos/mob/taxi-ponto.dto";
import { HttpGet, HttpPost, HttpPut, HttpResponse, JSONData, Quark, Url } from "sol-request-angular/dist/comunicacao";
import { IFilter } from "sol-request-angular/dist/comunicacao/interfaces/IFilter";
import { environment } from "src/environments/environment";

@Injectable()
export class TaxiPontoController implements ApiController<TaxiPonto>{
    constructor() { }

    find(filters ? : IFilter): Promise <TaxiPonto[]> {
        let request = new Quark(
            new HttpGet({
                url: new Url({
                    id: 'mob/taxiponto',
                    environment: environment,
                    filter: filters,
                }),
            }),
            new HttpResponse(new Array<TaxiPonto> ())
        );

        return request.call();
    }

    get(id: number): Promise <TaxiPonto> {
        let request = new Quark(
            new HttpGet({
                url: new Url({
                    id: 'mob/taxiponto/:cdPonto',
                    environment: environment,
                    pathParams: new JSONData({
                        cdPonto: id
                    }),
                }),
            }),
            new HttpResponse(new TaxiPonto())
    );

        return request.call();
    }

    create(entity: TaxiPonto): Promise <TaxiPonto> {
        let request = new Quark(
            new HttpPost({
                url: new Url({
                    id: 'mob/taxiponto',
                    environment: environment
                }),
                data: new JSONData(entity)
            }),
            new HttpResponse(
                new TaxiPonto()
            )
        );

        return request.call();
    }

    update(entity: TaxiPonto): Promise <TaxiPonto> {
        let request = new Quark(
            new HttpPut({
                url: new Url({
                    id: 'mob/taxiponto/:cdPonto',
                    environment: environment,
                    pathParams: new JSONData({
                        cdPonto: entity.cdPonto
                    })
                }),
                data: new JSONData(entity)
            }),
            new HttpResponse(
                new TaxiPonto()
            )
        );
        return request.call();
    }

    findLocais(filters ? : IFilter): Promise <TaxiPontoListDTO> {
        let request = new Quark(
            new HttpGet({
                url: new Url({
                    id: 'mob/taxiponto/locais',
                    environment: environment,
                    filter: filters,
                }),
            }),
            new HttpResponse(new TaxiPontoListDTO)
        );

        return request.call();
    }

    findPontos(filters ? : IFilter): Promise <TaxiPontoListDTO> {
        let request = new Quark(
            new HttpGet({
                url: new Url({
                    id: 'mob/taxiponto',
                    environment: environment,
                    filter: filters,
                }),
            }),
            new HttpResponse(new TaxiPontoListDTO())
        );

        return request.call();
    }
}